var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreams({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#5652D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8731 14C32.657 14 33.3029 14.186 33.9529 14.534C34.6069 14.882 35.1188 15.394 35.4668 16.046C35.8148 16.698 36.0008 17.346 36.0008 19.126V44.872C36.0008 46.656 35.8148 47.302 35.4668 47.952C35.1188 48.602 34.6069 49.118 33.9549 49.466C33.3029 49.814 32.655 50 30.8751 50H19.1277C17.3438 50 16.6978 49.814 16.0479 49.466C15.4017 49.1271 14.8737 48.5998 14.534 47.954C14.186 47.302 14 46.654 14 44.874V19.126C14 17.342 14.186 16.696 14.534 16.046C14.882 15.392 15.3939 14.88 16.0459 14.532C16.6978 14.184 17.3478 14 19.1277 14H30.8731ZM44.8723 18C46.6562 18 47.3021 18.186 47.9521 18.534C48.6061 18.882 49.118 19.394 49.466 20.046C49.814 20.698 50 21.346 50 23.126V40.872C50 42.656 49.814 43.302 49.466 43.952C49.118 44.602 48.6061 45.118 47.9541 45.466C47.3021 45.814 46.6542 46 44.8743 46H40.0006V18H44.8723Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreams);
export default __webpack_public_path__ + "static/media/streams.665d9b66e7248686a8f17dc5c6ddba4d.svg";
export { ForwardRef as ReactComponent };